export default class IsFileValidator {
	validate( value, label, errors ) {
		if ( value === null || value instanceof File ) { return true; }
		errors.push( `${label} should be a valid file.` );
		return false;
	}
}
